import slugify from 'slugify';

export default function getSlugText(text) {
  return slugify(text, { lower: true });
}
